import { IntegrationsMarketplaceHistoryLogsWebComponent } from './component/IntegrationsMarketplaceHistoryLogsWebComponent';

export { IntegrationsMarketplaceHistoryLogsWebComponent };
